export function IconDiamond() {
  return (
    <>
      <path
        d="M26.9382 11.7124L13.0607 11.8424L10.3388 12.8987L7.1132 16.2705L7.06445 16.4737L8.09633 17.6599L9.9082 19.7237L16.8632 25.7443L20.0645 28.2874L23.3876 25.5412L29.9363 19.7237L31.9513 17.5299L32.9345 16.4737V16.0918L29.4813 12.6955L26.9382 11.7124Z"
        stroke="currentColor"
        className="dynamic-stroke-width"
      />
      <path
        d="M24.999 19L21.4875 25.4501L20.0278 28L18.4933 25.4501L14.999 19"
        stroke="currentColor"
        className="dynamic-stroke-width"
      />
      <path
        d="M20.0642 19.5448H20.5642V19.3713L20.4567 19.235L20.0642 19.5448ZM17.5655 16.379L17.958 16.0692L17.1771 16.0641L17.5655 16.379ZM14.9993 19.5448L14.7089 19.9519L15.0916 20.2249L15.3877 19.8597L14.9993 19.5448ZM10.561 16.379L10.8513 15.9719L10.0725 16.2724L10.561 16.379ZM20.0642 28.2873H20.5642V19.5448H20.0642H19.5642V28.2873H20.0642ZM20.0642 19.5448L20.4567 19.235L17.958 16.0692L17.5655 16.379L17.173 16.6888L19.6718 19.8546L20.0642 19.5448ZM17.5655 16.379L17.1771 16.0641L14.6109 19.23L14.9993 19.5448L15.3877 19.8597L17.9539 16.6939L17.5655 16.379ZM14.9993 19.5448L15.2896 19.1377L10.8513 15.9719L10.561 16.379L10.2706 16.7861L14.7089 19.9519L14.9993 19.5448ZM10.561 16.379L10.0725 16.2724L9.36012 19.5373L9.84863 19.6438L10.3371 19.7504L11.0495 16.4856L10.561 16.379Z"
        fill="currentColor"
      />
      <path
        d="M22.5575 16.379L22.165 16.0692L22.9534 16.0736L22.5575 16.379ZM24.9994 19.5448L25.2844 19.9556L24.8938 20.2266L24.6035 19.8502L24.9994 19.5448ZM29.5621 16.379L29.2771 15.9682L30.0506 16.2724L29.5621 16.379ZM20.0588 19.5448L19.6663 19.235L22.165 16.0692L22.5575 16.379L22.95 16.6888L20.4513 19.8546L20.0588 19.5448ZM22.5575 16.379L22.9534 16.0736L25.3953 19.2394L24.9994 19.5448L24.6035 19.8502L22.1616 16.6844L22.5575 16.379ZM24.9994 19.5448L24.7144 19.134L29.2771 15.9682L29.5621 16.379L29.8471 16.7898L25.2844 19.9556L24.9994 19.5448ZM29.5621 16.379L30.0506 16.2724L30.7629 19.5373L30.2744 19.6438L29.7859 19.7504L29.0736 16.4856L29.5621 16.379Z"
        fill="currentColor"
      />
      <path
        d="M28.4998 12.4998L26.4998 15.9998L19.9404 11.7489"
        stroke="currentColor"
        className="dynamic-stroke-width"
        strokeLinejoin="bevel"
      />
      <path
        d="M11.499 12.4999L13.499 15.9999L19.9747 11.8676V16.1487"
        stroke="currentColor"
        className="dynamic-stroke-width"
        strokeLinejoin="bevel"
      />
      <line
        x1="7"
        y1="16.3"
        x2="33"
        y2="16.3"
        stroke="currentColor"
        className="dynamic-stroke-width"
      />
    </>
  )
}
